import React from 'react';
interface TrustpilotReviewProps {
  name: string;
  location: string;
  reviews: number;
  date: string;
  title: string;
  content: string;
  avatar?: string;
}
export function TrustpilotReview({
  name,
  location,
  reviews,
  date,
  title,
  content,
  avatar
}: TrustpilotReviewProps) {
  return <div className="bg-white rounded-lg p-4 shadow-md border border-gray-200 flex flex-col h-full" data-id="element-415">
      <div className="flex items-center mb-2" data-id="element-416">
        <div className="flex-shrink-0 mr-3" data-id="element-417">
          {avatar ? <img src={avatar} alt={`${name}'s avatar`} className="w-12 h-12 rounded-full object-cover" data-id="element-418" /> : <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 font-bold text-xl" data-id="element-419">
              {name.split(' ').map(part => part[0]).join('')}
            </div>}
        </div>
        <div data-id="element-420">
          <h4 className="font-semibold text-gray-900" data-id="element-421">{name}</h4>
          <div className="flex items-center text-sm text-gray-500" data-id="element-422">
            <span data-id="element-423">{location}</span>
            <span className="mx-1" data-id="element-424">•</span>
            <span data-id="element-425">
              {reviews} review{reviews !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
        <div className="ml-auto text-gray-500 text-sm" data-id="element-426">{date}</div>
      </div>
      <div className="flex mb-2" data-id="element-427">
        {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-428">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-429" />
          </svg>)}
      </div>
      <h3 className="font-bold text-gray-900 mb-2" data-id="element-430">{title}</h3>
      <p className="text-gray-700 mb-4 flex-grow" data-id="element-431">{content}</p>
      <div className="mt-auto flex items-center" data-id="element-432">
        <img src="https://cdn.trustpilot.net/brand-assets/1.1.0/logo-black.svg" alt="Trustpilot" className="h-4" data-id="element-433" />
        <span className="ml-2 text-sm text-gray-500" data-id="element-434">Verified review</span>
      </div>
    </div>;
}